/**
 * Linear Assets — Corridor Boundaries & Centreline Management (Step 1)
 */

import React, { useState } from 'react';
import { Route, Layers, MapPin, Plus, RefreshCw, Shield, AlertTriangle } from 'lucide-react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

export const LinearCorridorBoundariesPage: React.FC = () => {
  const [corridors] = useState([
    { id: 'lin-cor-01', name: 'Power Line Sector 7 (275kV Feeder)', type: 'Power Line', length_km: 124.5, buffer_m: 10, asset_count: 340, status: 'Active Monitoring' },
    { id: 'lin-cor-02', name: 'Main Western Rail Line (Sector B)', type: 'Railway', length_km: 210.0, buffer_m: 8, asset_count: 512, status: 'Active Monitoring' },
    { id: 'lin-cor-03', name: 'Highland Grid Interconnector (PL-12)', type: 'Power Line', length_km: 86.5, buffer_m: 10, asset_count: 190, status: 'Active Monitoring' },
    { id: 'lin-cor-04', name: 'Freight Line Corridor (Port Spur)', type: 'Railway', length_km: 42.0, buffer_m: 8, asset_count: 85, status: 'Active Monitoring' },
  ]);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <Route className="w-7 h-7 text-amber-500" /> Linear Corridor Boundaries (Step 1)
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Register power line and railway centrelines (LineString) with bilateral buffer zones for satellite monitoring
          </p>
        </div>
        <Button variant="primary" size="sm" className="flex items-center gap-1.5">
          <Plus className="w-4 h-4" /> Upload Corridor LineString
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {corridors.map((c) => (
          <Card key={c.id} className="p-4 border-t-4 border-amber-500">
            <span className="text-[10px] font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400">{c.type}</span>
            <h3 className="font-bold text-sm text-gray-900 dark:text-white mt-1 mb-2">{c.name}</h3>
            <div className="space-y-1 text-xs text-gray-500 dark:text-gray-400">
              <p>Length: <strong>{c.length_km} km</strong></p>
              <p>Clearance Buffer: <strong>{c.buffer_m} m bilateral</strong></p>
              <p>Pylons / Mast Assets: <strong>{c.asset_count}</strong></p>
            </div>
            <div className="mt-3 pt-2 border-t border-gray-100 dark:border-gray-800 text-[11px] text-green-600 font-semibold flex items-center gap-1">
              <Shield className="w-3.5 h-3.5" /> {c.status}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LinearCorridorBoundariesPage;
